export default "__VITE_ASSET__CGhCwx$9__"